module.exports = __webpack_public_path__ + "img/account-icon-active.b8d60eff.svg";